<header>
  <rrp-header />
</header>

<div class="layout-container">
  <section class="layout-menu">
    <lib-menu [items]="(getFilteredMenu() | async) || []" />
  </section>
  <div class="layout-content">
    <router-outlet />
  </div>
</div>
